// Utility functions for console logging in non-production environments.

export const consoleLog = (message: string, allowInProduction = false) => {
  if (window.$rails_env !== 'production' || allowInProduction) {
    // eslint-disable-next-line no-console
    console.log(message);
  }
};

export const consoleWarn = (message: string, allowInProduction = false) => {
  if (window.$rails_env !== 'production' || allowInProduction) {
    // eslint-disable-next-line no-console
    console.warn(message);
  }
};

export const consoleError = (
  message: string | Error,
  allowInProduction = false,
) => {
  if (window.$rails_env !== 'production' || allowInProduction) {
    console.error(message);
  }
};
